import React, { useEffect, useState,useRef } from "react";
import axios from "../axiosSetup";
import editIcon from "../assets/edit-icon.svg";
import deleteIcon from "../assets/delete.svg";
import noProductIcon from "../assets/Noproduct.svg";
import { Modal, message } from "antd";
import { formatMoney } from "../utils/formatMoney";
import "antd/dist/reset.css";
import "./AddNewQuotes.css";
import { getUser } from "../auth";
import CustomSelect from "../components/CustomSelect";
import CustomerEntitySelect from "../components/CustomerEntitySelect";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import Breadcrumbs from "../components/Breadcrumbs";

const { confirm } = Modal;

// 🔥 GENERIC BACKEND ERROR PARSER (ALL VALIDATION TYPES)
const extractApiErrors = (error) => {
  if (!error?.response) {
    return ["Network error. Please check your internet connection."];
  }

  // 🔥 UNWRAP COMMON BACKEND SHAPES
  let data = error.response.data;

  // unwrap { error: {...} }
  if (data?.error) data = data.error;

  // unwrap { data: {...} }
  if (data?.data) data = data.data;

  const userFriendlyMessage =
    data?.details?.userFriendlyMessage || data?.userFriendlyMessage;
  if (typeof userFriendlyMessage === "string" && userFriendlyMessage.trim()) {
    return [userFriendlyMessage.replace(/\\"/g, '"').trim()];
  }

  // string response
  if (typeof data === "string") {
    return [data];
  }

  // array directly
  if (Array.isArray(data)) {
    return data.map(String);
  }

  // ✅ Sequelize validation error
  if (Array.isArray(data?.details)) {
    return data.details.map(d => {
      if (typeof d === "string") return d;
      if (d?.path && d?.message) return `${d.path}: ${d.message}`;
      return d?.message || JSON.stringify(d);
    });
  }

  // express-validator / nest
  if (Array.isArray(data?.errors)) {
    return data.errors.map(e =>
      e?.msg || e?.message || JSON.stringify(e)
    );
  }

  // message array
  if (Array.isArray(data?.message)) {
    return data.message.map(String);
  }

  // message string
  if (typeof data?.message === "string") {
    return [data.message];
  }

  return ["Something went wrong. Please try again."];
};


export default function AddNewQuote() {
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [customerInfo, setCustomerInfo] = useState({});

  const [productCodes, setProductCodes] = useState([]);
  const [productSelectError, setProductSelectError] = useState("");
const [quantityError, setQuantityError] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [productDetails, setProductDetails] = useState(null);
  const [quantity, setQuantity] = useState("");
  const [totalPrice, setTotalPrice] = useState("");
  const [addedProducts, setAddedProducts] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [productComment, setProductComment] = useState("");
const [showProductCommentModal, setShowProductCommentModal] = useState(false);
const pendingProductRef = useRef(null);
  const navigate = useNavigate();
  const [selectedAddress, setSelectedAddress] = useState("");
  const [deliveryInstruction, setDeliveryInstruction] = useState("");
  const [showAddAddressModal, setShowAddAddressModal] = useState(false);
  const [orderLoaded, setOrderLoaded] = useState(false);

  const { quoteId } = useParams();
  const isQuoteEditMode = Boolean(quoteId);

  const [quoteExtra, setQuoteExtra] = useState({
    status: "",
    quoteDate: "",
    totalAmount: "",
    currency: "",
  poName: "", 
  });
  const [alert, setAlert] = useState({
  type: "error",
  message: "",
});
  const [addressForm, setAddressForm] = useState({
    line1: "",
    street: "",
    landmark: "",
    city: "",
    state: "",
    postalCode: "",
    country: ""
  });
const [addressErrors, setAddressErrors] = useState({
  line1: "",
  street: "",
  landmark: "",
  city: "",
  state: "",
  postalCode: "",
  country: ""
});
  const [showAddProductModal, setShowAddProductModal] = useState(false);

  const [loggedInUser, setLoggedInUser] = useState(null);
  const [isVocovoAdmin, setIsVocovoAdmin] = useState(false);

  const axiosWithAuth = axios.create({
    baseURL: axios.defaults.baseURL,
    withCredentials: true,
  });
const showApiErrorAlert = (err) => {
  const errors = extractApiErrors(err);

  setAlert({
    type: "error",
    message: errors.join("\n"),
  });
};
  useEffect(() => {
    const user = getUser();
    setLoggedInUser(user);
    setIsVocovoAdmin(user?.userType !== "customer");
  }, []);

  // Load customers (admin) or single customer (customer)
  useEffect(() => {
    if (loggedInUser === null) return;

    const loadData = async () => {
      try {
        if (isVocovoAdmin) {
          const customerRes = await axiosWithAuth.get("/dropdown/customers");
          setCustomers(customerRes.data || []);
        } else {
          const res = await axiosWithAuth.get(`/dropdown/customer/${loggedInUser.id}`);
          setCustomerInfo(res.data || {});
          setSelectedCustomer(String(res.data.id));
        }
      } catch (err) {
        console.error("Failed loading customer data", err);
      }
    };

    loadData();
  }, [isVocovoAdmin, loggedInUser]);

  // load customer details (addresses) when selection changes
  useEffect(() => {
  if (!selectedCustomer) return;

  // 🔒 In edit mode, wait until customers are loaded
  if (isQuoteEditMode && customers.length === 0) return;

  const loadCustomerInfo = async () => {
    try {
      const customerId = isVocovoAdmin
        ? customers.find(c => String(c.id) === selectedCustomer)?.id
        : selectedCustomer;

      if (!customerId) return;

      const res = await axiosWithAuth.get(
        "/dropdown/customer-details",
        { params: { customerId } }
      );

      setCustomerInfo(res.data || {});
    } catch (err) {
      console.error("Failed loading customer info", err);
    }
  };

  loadCustomerInfo();
}, [selectedCustomer, customers, isQuoteEditMode]);

useEffect(() => {
  // when customer changed -> clear products and selections
  if (isQuoteEditMode) return;
  setAddedProducts([]);
  setSelectedAddress("");
  setShowAddProductModal(false);
  setProductDetails(null);
  setSelectedProduct("");
  setQuantity("");
  setTotalPrice("");
  setProductSelectError("");
  setQuantityError("");
}, [selectedCustomer,isQuoteEditMode]);
  // Load quote for edit mode
  useEffect(() => {
    if (!isQuoteEditMode) return;
    if (isVocovoAdmin && customers.length === 0) return;
  if (!isVocovoAdmin && !loggedInUser) return;
    const loadQuote = async () => {
      try {
        const res = await axiosWithAuth.get(`/quote/${quoteId}`);
        const quote = res.data;
        setCustomers(prev => {
  const exists = prev.some(
    c => String(c.id) === String(quote.customer.id)
  );
  if (exists) return prev;
  return [...prev, { id: quote.customer.id, name: quote.customer.name }];
});
        setSelectedCustomer(String(quote.customer.id));
        setSelectedAddress(String(quote.deliveryAddress?.id || ""));
        setDeliveryInstruction(quote.deliveryInstruction || "");
        setQuoteExtra({
          status: quote.status,
          quoteDate: quote.createdAt,
          totalAmount: quote.total,
          createdBy: quote.createdBy?.name,
          updatedBy: quote.updatedBy?.name,
          currency: quote.currency,
          poName: quote.name,  
        });

        setAddedProducts(
          (quote.products || []).map((p) => ({
            quoteProductId: p.quoteProductId,
            quoteId: p.quoteId,
            productCode: p.productCode,
            quantity: p.quantity,
            rrp: p.rrp,
            discount: p.discount,
            itemType: p.itemType,
            totalPrice: p.total?.toFixed(2),
            currency:quote.currency,
            discountType:p.discountType?.toLowerCase(),
            productType:p.productType,
            taxes:quote.taxes || [],
          }))
        );
        setOrderLoaded(true);
      } catch (err) {
        console.error("Failed to load quote", err);
      }
    };

    loadQuote();
  }, [isQuoteEditMode, quoteId,customers.length,   // 👈 ADD
  loggedInUser,       // 👈 ADD 
  isVocovoAdmin ]);

  // ensure selectedAddress is present in loaded customer addresses
  useEffect(() => {
    if (!isQuoteEditMode) return;
    if (!orderLoaded) return;
    if (!customerInfo.addresses) return;
    const exists = customerInfo.addresses.some((a) => String(a.id) === String(selectedAddress));
    if (exists) setSelectedAddress(String(selectedAddress));
  }, [customerInfo, orderLoaded, isQuoteEditMode]);

  // load product codes
 useEffect(() => {
   if (!selectedCustomer) return; // ❗ wait until customer is selected
 
   const loadProducts = async () => {
     try {
       const res = await axiosWithAuth.get("/dropdown/product-code", {
         params: { customerId: selectedCustomer }
       });
 
       console.log("🔥 Product Codes:", res.data);
       setProductCodes(res.data || []);
     } catch (err) {
       console.error("❌ Failed loading product codes", err);
     }
   };
 
   loadProducts();
 }, [selectedCustomer]);

  // fetch product details and customer-specific discount/pricing
  const handleProductSelect = async (productCode) => {
    try {
      const userInfo = JSON.parse(localStorage.getItem("APP_USER_INFO") || "{}");
      let customerId;
      if (userInfo?.role?.toLowerCase() === "customer") customerId = userInfo.id;
      else {
        const selectedCustomerObj = customers.find((c) => String(c.id) === String(selectedCustomer));
        customerId = selectedCustomerObj?.id;
      }

      if (!customerId) {
        console.warn("No valid customer ID for product price request");
        return;
      }

      const res = await axios.get("/dropdown/product-prices-and-customer-discount", {
        params: { productCode, customerId, isQuote:true }
      });

      let productData = res.data;
if (Array.isArray(productData)) productData = productData[0];
else if (productData?.data) productData = productData.data;

const normalizedProductData = {
  ...productData,
  discountType: productData?.discountType?.toLowerCase(),
};

setSelectedProduct(productCode.trim().toUpperCase());
setProductDetails(normalizedProductData);

if (normalizedProductData?.comments) {
  setProductComment(normalizedProductData.comments);
} else {
  setProductComment("");
}

setQuantity("");
setTotalPrice("");

    } catch (err) {
      console.error("Failed to fetch product details", err);
      message.error("Failed to fetch product details");
    }
  };

const JS_MAX_SAFE = 9007199254740991;
const handleQuantityChange = (qty) => {
  if (!productDetails) {
    setQuantity("");
    setTotalPrice("");
    setQuantityError("Please select a product first");
    return;
  }
  const num = qty === "" ? "" : Number(qty);
  const minQty = Number(productDetails.minimumOrderQuantity);
  setQuantity(num);

  if (!productDetails || num === "") {
    setTotalPrice("");
    return;
  }
  if (num > JS_MAX_SAFE) {
    setQuantityError(`Quantity cannot exceed ${JS_MAX_SAFE}`);
    return;
  }
  if (num < 0) {
    setQuantityError("Quantity cannot be negative");
    return;
  }

  // 🛑 Minimum quantity validation
  if (num > 0 && num < minQty) {
    setQuantityError(`Minimum quantity is ${minQty}`);
    return;
  }

  // 🛑 Max quantity validation
  if (num > 100000) {
    setQuantityError("Quantity cannot exceed 100000");
    return;
  }

  // 🛑 Multiple validation
  if (num > 0 && num % minQty !== 0) {
    setQuantityError(`Quantity must be in multiples of ${minQty}`);
    return;
  }


  // 🚫 VALIDATION: Must be a multiple of minimumOrderQuantity
  if (num % minQty !== 0) {
    setTotalPrice("");
    setQuantityError(
  `Quantity must be a multiple of ${minQty} (like ${minQty}, ${minQty * 2}, ${minQty * 3}, ...)`
);
setQuantityError("");
    return;
  }

  // Clear error once valid
  setQuantityError("");

  // Calculate total price
  const customerPrice = Number(productDetails.customerPrice || 0);
  const subtotal = customerPrice * num;

// // total tax %
// const totalTaxPercent = (customerInfo?.taxes || [])
//   .reduce((sum, t) => sum + Number(t.percentage || 0), 0);

// // AFTER tax
// const totalWithTax = subtotal + (subtotal * totalTaxPercent) / 100;

setTotalPrice(subtotal.toFixed(2));
};

  const handleEdit = async (index) => {
  const p = addedProducts[index];

  setIsEditMode(true);
  setEditIndex(index);
  setShowAddProductModal(true);

  setSelectedProduct(p.productCode.trim().toUpperCase());
  setQuantity(p.quantity);
  setTotalPrice(String(p.totalPrice));

  try {
    let customerId;
    const userInfo = JSON.parse(localStorage.getItem("APP_USER_INFO") || "{}");

    if (userInfo?.role?.toLowerCase() === "customer") {
      customerId = userInfo.id;
    } else {
      const selectedCustomerObj = customers.find(
        (c) => String(c.id) === String(selectedCustomer)
      );
      customerId = selectedCustomerObj?.id;
    }

    if (!customerId) return;

    // 🔥 SAME API AS ADD FLOW
    const res = await axios.get(
      "/dropdown/product-prices-and-customer-discount",
      {
        params: {
          productCode: p.productCode,
          customerId,
          isQuote: true
        },
      }
    );

    let productData = res.data;
    if (Array.isArray(productData)) productData = productData[0];
    else if (productData?.data) productData = productData.data;
    const normalizedProductData = {
  ...productData,
  discountType: productData?.discountType?.toLowerCase(),
};

setProductDetails(normalizedProductData);

if (normalizedProductData?.comments) {
  setProductComment(normalizedProductData.comments);
} else {
  setProductComment("");
}
    setProductDetails(productData || {});
  } catch (err) {
    console.error("Failed to load product details for edit", err);
    message.error("Failed to load product details");
  }
};

const validateAddressField = (field, value) => {
  let error = "";

  if (["line1", "street", "landmark","city"].includes(field)) {
    if (!value.trim()) error = "This field is required";
  }
  if (field === "country") {
  if (!value.trim()) error = "Country is required";
  else if (value.length < 3 || value.length > 50)
    error = "Give a valid country name of minimum 3 characters.";
}

    if (field === "state") {
    if (!value.trim()) error = "State is required";
    else if (value.length < 3 || value.length > 50)
      error = "Give a valid state name of minimum 3 characters.";
  }

  if (field === "postalCode") {
    if (!value.trim()) error = "Postal code is required";
    else if (!/^[0-9A-Za-z\- ]{3,10}$/.test(value))
      error = "Invalid postal code";
  }

  setAddressErrors(prev => ({ ...prev, [field]: error }));
  return error === "";
};
const formatAddress = (a) => {
  return [
    a.line1,
    a.street,
    a.landmark,
    a.city,
    a.state,
    a.postalCode,
    a.country
  ]
    .filter(Boolean)              // remove null/empty values
    .join(", ");
};
const resetAddressForm = () => {
  setAddressForm({
    line1: "",
    street: "",
    landmark: "",
    city: "",
    state: "",
    postalCode: "",
    country: ""
  });

  setAddressErrors({
    line1: "",
    street: "",
    landmark: "",
    city: "",
    state: "",
    postalCode: "",
    country: ""
  });
};

  const handleDeleteProduct = (index) => {
    if (typeof index !== "number") return;
    const ok = window.confirm("Delete product from quote?");
    if (!ok) return;
    setAddedProducts((prev) => prev.filter((_, i) => i !== index));
  };

  // address modal helpers
  const openAddAddress = () => {
   resetAddressForm();
    setShowAddAddressModal(true);
  };
const handleAddressChange = (field, value) => {
  setAddressForm(p => ({ ...p, [field]: value }));
  validateAddressField(field, value);
};

  const saveAddress = async () => {
    const fieldsToCheck = ["line1", "street", "landmark", "city", "state", "postalCode", "country"];

  let allValid = true;
  fieldsToCheck.forEach(f => {
    const ok = validateAddressField(f, addressForm[f] || "");
    if (!ok) allValid = false;
  });

  if (!allValid) {
    message.error("Please fix the highlighted fields");
    return;
  }
    try {
      let customerId;
      if (isVocovoAdmin) {
        const selectedCustomerObj = customers.find((c) => String(c.id) === String(selectedCustomer));
        customerId = selectedCustomerObj?.id;
      } else {
        customerId = customerInfo.id;
      }
      if (!customerId) return message.error("No valid customer found");
      await axiosWithAuth.post("quote/add-customer-address", { customerId, ...addressForm });
      message.success("Address added");
      setShowAddAddressModal(false);
          const refreshRes = await axiosWithAuth.get(`/dropdown/customer-details`, {
  params: { customerId }
});
      setCustomerInfo(refreshRes.data || {});
      setSelectedAddress("");
    } catch (err) {
      console.error("Failed to save address", err);
      message.error(err?.response?.data?.message || "Failed to save address");
    }
  };

  const isSubmitDisabled = !selectedCustomer || !selectedAddress || addedProducts.length === 0;

  const actuallyAddProduct = () => {
  const productToAdd = {
    productCode: selectedProduct,
    itemType: productDetails?.itemType,
    productType: productDetails?.productType,
    rrp: Number(productDetails?.rrp),
    discount: Number(productDetails?.discount),
    quantity: Number(quantity),
    totalPrice: Number(totalPrice),
    discountType: productDetails?.discountType,
    currency: productDetails?.currency,
    // taxes: (customerInfo?.taxes || []).map(t => ({
    //   name: t.name,
    //   percentage: t.percentage,
    // })),
  };

  if (isEditMode && editIndex !== null) {
    const updated = [...addedProducts];
    updated[editIndex] = {
      ...productToAdd,
      quoteProductId: addedProducts[editIndex].quoteProductId,
      quoteId: addedProducts[editIndex].quoteId,
    };
    setAddedProducts(updated);
  } else {
    setAddedProducts(prev => [...prev, productToAdd]);
    message.success("Product added");
  }

  resetProductModal();
  setShowAddProductModal(false);
};

  const addOrUpdateProduct = () => {
  if (!selectedProduct || !quantity) {
    message.error("Please select product & enter quantity");
    return;
  }

  if (!isEditMode) {
    const normalized = selectedProduct.trim().toUpperCase();
    const exists = addedProducts.some(
      ap => ap.productCode.trim().toUpperCase() === normalized
    );
    if (exists) {
      setProductSelectError("This product is already added.");
      return;
    }
  }

  // 🔥 COMMENT GATE (QUOTE)
  if (productComment) {
    pendingProductRef.current = true;
    setShowProductCommentModal(true);
    return;
  }

  actuallyAddProduct();
};


  const handleSubmitQuote = async () => {
    if (!selectedCustomer) return message.error("Please select a customer");
    if (!selectedAddress) return message.error("Please select an address");
    if (addedProducts.length === 0) return message.error("Please add products");
    if (isSubmitting) return;     // 👈 ignore double-click
    setIsSubmitting(true);
    try {
      let customerId;
      if (isVocovoAdmin) {
        const selectedCustomerObj = customers.find((c) => String(c.id) === String(selectedCustomer));
        customerId = selectedCustomerObj?.id;
      } else {
        customerId = customerInfo.id;
      }
      if (!customerId) return message.error("Customer ID not found.");

      const payload = {
        id: Number(quoteId) || undefined,
        customerId,
        name: `Quote-${Date.now()}`,
        deliveryAddressId: Number(selectedAddress),
        deliveryInstruction:
    deliveryInstruction?.trim() === "" ? null : deliveryInstruction.trim(),
        products: addedProducts.map((p) => ({
          id: p.id,
          productCode: p.productCode,
          quantity: Number(p.quantity),
          rrp: Number(p.rrp),
          discount: Number(p.discount),
          finalPrice: Number(p.totalPrice)
        }))
      };

      let res;
      if (isQuoteEditMode) {
        res = await axiosWithAuth.put(`/quote/${quoteId}`, payload);
        message.success("Quote updated successfully!");
      } else {
        res = await axiosWithAuth.post("/quote", payload);
        message.success("Quote created successfully!");
      }

      // redirect
      setTimeout(() => navigate("/quotes"), 500);

      // reset
      setSelectedCustomer("");
      setCustomerInfo({});
      setSelectedAddress("");
      setAddedProducts([]);
    } catch (err) {
  console.error("Quote submit failed", err);
  showApiErrorAlert(
    err,
    isQuoteEditMode ? "Update Quote Failed" : "Create Quote Failed"
  );
  setIsSubmitting(false);
}
  };
const resetProductModal = () => {
  setSelectedProduct("");
  setProductDetails(null);
  setQuantity("");
  setTotalPrice("");
  setProductSelectError("");
  setQuantityError(""); 
  setIsEditMode(false);
  setEditIndex(null);
};
const showCustomerAddressValidation =
  !selectedCustomer || !selectedAddress;

const subtotal =
  Number(productDetails?.customerPrice || 0) * Number(quantity || 0);

const activeCurrency =
  customerInfo?.currency ||
  productDetails?.currency ||
  "";
// const orderTaxPercent = (customerInfo?.taxes || []).reduce(
//   (sum, t) => sum + Number(t.percentage || 0),
//   0
// );

// const editedSubtotal =
//   Number(productDetails?.customerPrice || 0) * Number(quantity || 0);

//     const taxBreakdown = (customerInfo?.taxes || []).map(t => ({
//   name: t.name,
//   percentage: t.percentage,
//   amount: (editedSubtotal * Number(t.percentage || 0)) / 100,
// }));

  return (
    <div className="add-order-wrapper">
      <div className="header-row">
        <Breadcrumbs />
        {/* <h2>{isQuoteEditMode ? "Edit Quote" : "Add New Quote"}</h2> */}
      </div>
      {/* <p className="sub-text">{isQuoteEditMode ? "Update the quote details" : "Create a new quote"}</p> */}
      {showCustomerAddressValidation && (
  <div
    style={{
      padding: "10px 10px",
      paddingBottom: "0",
      color: "#FFFFFF",
      fontSize: "14px",
      fontWeight: 500,
    }}
  >
    Please select Customer Name and Address.
  </div>
)}
      {/* Customer Info Card */}
      <div className="card">
        <h3>Customer Information</h3>

        <div className="grid">
          <div className="field">
            <label>Customer Name</label>
            {isVocovoAdmin ? (
              <CustomerEntitySelect
                value={selectedCustomer}
                onChange={(v) => setSelectedCustomer(v)}
                disabled={isQuoteEditMode}
                placeholder="Select Customer"
                width="100%"
                options={[
                  {
                    value: "",
                    customerName: "Select Customer",
                    entityName: "-",
                    searchText: "select customer",
                  },
                  ...customers.map((c) => ({
                    value: String(c.id),
                    customerName: c.name || "-",
                    entityName:
                      c.entityName || c.entity || c.company || c.organization || c.businessName || "-",
                    searchText: `${c.name || ""} ${
                      c.entityName || c.entity || c.company || c.organization || c.businessName || ""
                    }`,
                  }))
                ]}
              />
            ) : (
              <input disabled value={customerInfo.name || "-"} />
            )}
          </div>

          <div className="field">
            <label>Customer Id</label>
            <span style={{color: "#9A49CD"}}>{customerInfo.id || "-"}</span>
          </div>

          <div className="field">
            <label>Email</label>
            <span style={{color: "#9A49CD"}}>{customerInfo.email || "-"}</span>
          </div>

          <div className="field">
            <label>Delivery Address</label>

            {/* {isVocovoAdmin && customerInfo.addresses?.length === 0 && (
              <p style={{ color: "#DC2626", fontSize: "14px", marginTop: "8px" }}>
                This customer does not have any delivery address. They must add one before creating a quote.
              </p>
            )} */}

            {customerInfo.addresses?.length === 0 && (
              <CustomSelect value="add_new" onChange={() => openAddAddress()} width="100%" options={[{ label: "+ Add New Address", value: "add_new" }]} />
            )}

            {customerInfo.addresses?.length> 0 && (
              <CustomSelect
                value={selectedAddress}
                 onChange={(v) => {
    if (v === "add_new") {
      openAddAddress();   // ✅ THIS OPENS THE MODAL
      return;
    }
    setSelectedAddress(v);
  }}
                placeholder="Select Address"
                width="100%"
                options={[
                  ...customerInfo.addresses.map((a) => ({ label: formatAddress(a), value: String(a.id) })),
                  { label: "+ Add New Address", value: "add_new" }
                  // ...(!isVocovoAdmin ? [{ label: "+ Add New Address", value: "add_new" }] : [])
                ]}
              />
            )}
          </div>

          <div className="field">
            <label>Phone No</label>
            <span style={{color: "#9A49CD"}}>{customerInfo.phoneNo || "-"}</span>
          </div>

          <div className="field">
            <label>Delivery Instruction</label>
            <input placeholder="Enter Delivery Instruction" 
            value={deliveryInstruction}
  onChange={(e) => setDeliveryInstruction(e.target.value)}/>
          </div>
        </div>

        {/* Extra info when editing */}
        {isQuoteEditMode && (
          <div className="extra-info-grid">
            <div className="field">
              <label>Status</label>
              <span className={`status-badge ${quoteExtra.status?.toLowerCase()}`}>{quoteExtra.status || "-"}</span>
            </div>

            <div className="field">
              <label>Quote Date</label>
              <span style={{color: "#9A49CD"}}>{quoteExtra.quoteDate ? new Date(quoteExtra.quoteDate).toLocaleDateString() : "-"}</span>
            </div>

            <div className="field">
              <label>Total Amount</label>
              <span style={{color: "#9A49CD"}}>
   {formatMoney(quoteExtra.totalAmount, quoteExtra.currency)}

</span>
            </div>

            {/* <div className="field">
              <label>Created By</label>
              <span>{quoteExtra.createdBy || "-"}</span>
            </div>

            <div className="field">
              <label>Updated By</label>
              <span>{quoteExtra.updatedBy || "-"}</span>
            </div> */}
          </div>
        )}
{isQuoteEditMode && (
  <div className="field">
    <label>Purchase Order Name</label>
    <span style={{ color: "#9A49CD" }}>
      {quoteExtra.poName || "-"}
    </span>
  </div>
)}
      </div>

      {/* Products Card */}
      <div className="card">
        <div className="product-header">
          <h3>Products</h3>
          <button
            className="add-btn"
            style={{ fontSize: "14px", fontWeight: "500", lineHeight: "20px" }}
            onClick={() => {
  resetProductModal();  // always open fresh
  setShowAddProductModal(true);
}}
            disabled={!selectedCustomer || !selectedAddress}
          >
            + Add Products
          </button>
        </div>

        {addedProducts.length === 0 ? (
          <div className="empty-box">
            <img src={noProductIcon} alt="no product" />
            <p className="no-title">No Product Yet</p>
            <p className="no-sub">Add Products to your PO</p>
          </div>
        ) : (
          <div className="product-table-wrapper">
            <table className="product-table">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Item Type</th>
                  <th>Qty</th>
                  <th>RRP</th>
                  <th>Discount</th>
                  <th>Total </th>
 {/* <th>Total (After Tax)</th> */}

{/* {customerInfo?.taxes?.map(t => (
  <th key={t.name}>{t.name} (%)</th>
))} */}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {addedProducts.map((p, i) => (
                  <tr key={i}>
                    <td>{p.productCode.toLowerCase()}</td>
                    <td>{p.itemType}</td>
                    <td>{p.quantity}</td>
                    <td>{formatMoney(p.rrp, p.currency)}</td>
 
<td>
  {p.discountType === "percentage"
    ? `${p.discount}%`
    : formatMoney(p.discount, p.currency)}
</td>
 
<td>{formatMoney(p.totalPrice, p.currency)}</td>

{/* <td>
  {p.currency}
  {(Number(p.totalPrice) * (1 + orderTaxPercent / 100)).toFixed(2)}
</td> */}

{/* {customerInfo?.taxes?.map(tax => {
  const match = (p.taxes || []).find(x => x.name === tax.name);
  return (
    <td key={tax.name}>
      {match ? `${match.percentage}%` : "-"}
    </td>
  );
})} */}
                    <td style={{ padding: "6px", display: "flex", gap: "8px" }}>
                      <img src={editIcon} alt="edit" width="20" onClick={() => handleEdit(i)} style={{ cursor: "pointer" }} />
                      <img src={deleteIcon} alt="delete" onClick={() => handleDeleteProduct(i)} style={{ cursor: "pointer" }} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="btn-row">
        <button className="cancel-btn" onClick={() => navigate("/quotes")}>Cancel</button>
        <button className="submit-btn" onClick={handleSubmitQuote} disabled={isSubmitDisabled || isSubmitting} style={{ cursor: isSubmitDisabled || isSubmitting? "not-allowed" : "pointer" }}>
           {isSubmitting
    ? (isQuoteEditMode ? "Updating..." : "Submitting...")
    : (isQuoteEditMode ? "Update PO" : "Submit PO")}
        </button>
      </div>

      {/* Add / Edit Product Modal */}
      {showAddProductModal && (
        <div className="modal-overlay">
          <div className="modal add-product-modal">
            <div className="modal-header">
              <h3>{isEditMode ? "Edit Product" : "Add Product"}</h3>
              <button
  className="close-btn"
  onClick={() => {
    resetProductModal();
    setShowAddProductModal(false);
  }}
>
  ✖
</button>

            </div>
            <p className="modal-subtext">Add a new Product to your quote</p>

            <div className="grid-2">
              <div className="field">
                <label>Select Product</label>
                <CustomSelect
                  value={selectedProduct}
                  placeholder="Select Product"
                  width="100%"
                  disabled={isEditMode}  
                  onChange={(v) => { 
  setProductSelectError("");
  handleProductSelect(v.trim().toUpperCase()); 
}}
                  options={[
                    { label: "Select Product", value: "" },
                    ...productCodes.map((p) => {
                      const code = p.productCode.trim().toUpperCase();
                      const isUsed = addedProducts.some(
    (ap, idx) =>
      ap.productCode.trim().toUpperCase() === code &&
      idx !== editIndex          // 👈 allow the one we're editing
  );
                       return {
    label: `${p.productCode} — ${p.productDescription}`,
    value: code,
    disabled: isUsed && !isEditMode,   // 👈 still prevent duplicates when adding
  };
                    })
                  ]}
                />
               {productSelectError && <p className="input-error">{productSelectError}</p>}
              </div>

              <div className="field">
                <label>Quantity</label>
                <input
  type="number"
  placeholder="Enter quantity"
  value={quantity}
  min="1"
  onChange={(e) => {
    const val = e.target.value;

    // block negatives, zero, or non-numbers
    if (val === "" || Number(val) < 1) {
      setQuantity("");
      return;
    }
    setQuantityError("");
    handleQuantityChange(val);
  }}
/>
{quantityError && (
  <p className="input-error">{quantityError}</p>
)}
              </div>

              <div className="field">
                <label>Customer Discount</label>
               <input
  disabled
  value={
    !productDetails
      ? "-"
      : productDetails.discountType?.toLowerCase() === "percentage"
      ? `${productDetails.discount}%`
      : productDetails.discountType?.toLowerCase() === "fixed price"
      ? `${productDetails.currency}${productDetails.discount}`
      : "-"
  }
/>
              </div>

              <div className="field">
                <label>Type of Product</label>
                <input disabled value={productDetails?.productType || "-"} />
              </div>

              <div className="field">
                <label>Item Type</label>
                <input disabled value={productDetails?.itemType || "-"} />
              </div>

              <div className="field">
                <label>RRP</label>
                <input
  disabled
  value={
    productDetails?.rrp
      ? formatMoney(productDetails.rrp, productDetails.currency)
      : "-"
  }
/>
              </div>

              {/* <div className="field">
  <label>Total Price (before tax)</label>
<input
  disabled
  value={
    totalPrice
      ? `${activeCurrency}${Number(totalPrice).toFixed(2)}`
      : "-"
  }
/>

</div>
{taxBreakdown.map(t => (
  <div className="field" key={t.name}>
    <label>{t.name} ({t.percentage}%)</label>
    <input disabled value={`${activeCurrency}${t.amount.toFixed(2)}`} />
  </div>
))}
<div className="field">
  <label>Total Price (incl. tax)</label>
   <input
  disabled
  value={`${activeCurrency}${
    (Number(totalPrice) * (1 + orderTaxPercent / 100)).toFixed(2)
  }`}
/>
</div> */}

<div className="field">
  <label>Total Price</label>
  <input
  disabled
  value={
    totalPrice
      ? formatMoney(totalPrice, activeCurrency)
      : "-"
  }
/>
</div>

            </div>

            <div className="modal-actions-row">
              <button className="cancel-btn" onClick={() => {
  resetProductModal();  // always open fresh
  setShowAddProductModal(false);
}}>Cancel</button>
             <button
  className="submit-btn"
  onClick={addOrUpdateProduct}
  style={{
    cursor: !quantity ? "not-allowed" : "pointer"
  }}
  disabled={!quantity}   // prevents clicking when no quantity
>
  {isEditMode ? "Update Product" : "Add Product"}
</button>
            </div>
          </div>
        </div>
      )}

      {/* Add Address Modal */}
      {showAddAddressModal && (
        <div className="address-modal-overlay">
          <div className="address-modal">
            <div className="address-modal-header">
              <div>
                <h2>Add New Address</h2>
                <p>Add a new delivery address</p>
              </div>
              <button
  className="close-icon"
  onClick={() => {
    resetAddressForm();
    setShowAddAddressModal(false);
  }}
>
  ✖
</button>

            </div>

            <div className="address-grid">
              <div className="field">
                <label>Apartment, floor, or building name</label>
                <input placeholder="Enter" maxLength={100}
                value={addressForm.line1} onChange={(e) => handleAddressChange("line1", e.target.value)} />
                {addressErrors.line1 && (
    <p className="input-error">{addressErrors.line1}</p>
  )}
              </div>

              <div className="field">
                <label>Street address</label>
                <input placeholder="Enter" maxLength={100} value={addressForm.street} onChange={(e) => handleAddressChange("street", e.target.value)} />
                {addressErrors.street && (
    <p className="input-error">{addressErrors.street}</p>
  )}
              </div>

              <div className="field">
                <label>Landmark</label>
                <input placeholder="Enter" maxLength={100} value={addressForm.landmark} onChange={(e) => handleAddressChange("landmark", e.target.value)} />
                {addressErrors.landmark && (
    <p className="input-error">{addressErrors.landmark}</p>
  )}
              </div>

              <div className="field">
                <label>City</label>
                <input placeholder="Enter" maxLength={100} value={addressForm.city} onChange={(e) => handleAddressChange("city", e.target.value)} />
                {addressErrors.city && (
    <p className="input-error">{addressErrors.city}</p>
  )}
              </div>

              <div className="field">
                <label>State / Province</label>
                <input placeholder="Enter" maxLength={100} value={addressForm.state} onChange={(e) => handleAddressChange("state", e.target.value)} />
                {addressErrors.state && (
    <p className="input-error">{addressErrors.state}</p>
  )}
              </div>

              <div className="field">
                <label>ZIP / Postal code</label>
                <input placeholder="Enter" maxLength={100} value={addressForm.postalCode} onChange={(e) => handleAddressChange("postalCode", e.target.value)} />
                {addressErrors.postalCode && (
    <p className="input-error">{addressErrors.postalCode}</p>
  )}
              </div>

              <div className="field full-width">
                <label>Country</label>
                <input placeholder="Enter" maxLength={100} value={addressForm.country} onChange={(e) => handleAddressChange("country", e.target.value)} />
                {addressErrors.country && (
    <p className="input-error">{addressErrors.country}</p>
  )}
              </div>
            </div>

            <div className="address-modal-actions">
              <button
  className="cancel-btn"
  onClick={() => {
    resetAddressForm();
    setShowAddAddressModal(false);
  }}
>
  Cancel
</button>
              <button className="add-btn" onClick={saveAddress}>Add Address</button>
            </div>
          </div>
        </div>
      )}
      {showProductCommentModal && (
  <div className="modal-overlay">
    <div className="modal">
      <div className="modal-header">
        <h3>Product Comment</h3>
        <button
          className="close-btn"
          onClick={() => setShowProductCommentModal(false)}
        >
          ✖
        </button>
      </div>

      <div
        style={{
          padding: "16px",
          fontSize: "14px",
          whiteSpace: "pre-wrap",   // ✅ multiline support
          lineHeight: "1.5",
        }}
      >
        {productComment}
      </div>

      <div className="modal-actions-row">
        <button
          className="cancel-btn"
          onClick={() => {
            setShowProductCommentModal(false);
            pendingProductRef.current = null;
          }}
        >
          Cancel
        </button>

        <button
          className="submit-btn"
          onClick={() => {
            setShowProductCommentModal(false);
            pendingProductRef.current = null;
            actuallyAddProduct();   // ✅ CONFIRM ADD
          }}
        >
          Continue
        </button>
      </div>
    </div>
  </div>
)}
{alert.message && (
  <div className="alert-overlay">
    <div className={`alert-popup ${alert.type}`}>
      <div className="alert-header">
        <span>Error</span>
        <button
          className="alert-close"
          onClick={() => setAlert({ type: "", message: "" })}
        >
          ✖
        </button>
      </div>

      <div
        className="alert-body"
        style={{ whiteSpace: "pre-wrap" }}   // 🔥 multiline support
      >
        {alert.message}
      </div>

      <div className="alert-footer">
        <button
          className="alert-ok-btn"
          onClick={() => setAlert({ type: "", message: "" })}
        >
          OK
        </button>
      </div>
    </div>
  </div>
)}


    </div>
  );
}
